import React from "react";
import { dispatch } from "@rematch/core";
import _ from "lodash";
import { Form } from "formsy-semantic-ui-react";
import './customSurveyjs.css';

import {
  Button,
  Tab,
  Header,
  Modal,
  Message,
  Grid,
  Icon
} from "semantic-ui-react";

class ShowPlaybookMetaData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isJSONValid: true,
      updatedMetaDataSchema: this.props.metaDataSchema,
      alreadyExist: false,
      optCheck: true,
      btnDisabled: false
    };
  }

  close = () => {
    this.props.setMetaDataFlag(false);
    this.setState({alreadyExist: false})
  };

  IsValidJSONString = (e, data) => {
    try {
      JSON.parse(e.target.value)
    } catch (error) {
      this.setState({ isJSONValid: false, btnDisabled: true });
      return false
    }
    if(!Array.isArray(JSON.parse(e.target.value))) {
      this.setState({ isJSONValid: false, btnDisabled: true });
      return false
    }
    if(Array.isArray(JSON.parse(e.target.value))) {
        for(let dataField of JSON.parse(e.target.value)){
        let fields = Object.keys(dataField)
        if(!dataField.hasOwnProperty("type")) {
          this.setState({ isJSONValid: false, btnDisabled: true });
          break;
        }
        if(dataField.type === "boolean") {
          if(dataField.hasOwnProperty("title") && dataField.hasOwnProperty("name")) {
            this.setState({
              isJSONValid: true,
              btnDisabled: false
            });
            
            const requiredKeys = ['title', 'name', 'type']
            const optionalKeys = ['isRequired', 'detail', 'isRestricted', 'placeholder','metaData'] 
            let allRequiredFound = requiredKeys.every(key => fields.includes(key)) 
            let validKeys = fields.every(key => requiredKeys.includes(key) || optionalKeys.includes(key))
            if(allRequiredFound && validKeys) {
              this.setState({optCheck: true, btnDisabled: false, updatedMetaDataSchema: JSON.parse(e.target.value),})
            }
            else {
              this.setState({optCheck: false, btnDisabled: true})
              break;
            }
          }
          else {
            this.setState({ isJSONValid: false, btnDisabled: true });
            break;
          }
        }
        if(dataField.type === "checkbox") {
          if(dataField.hasOwnProperty("title") && dataField.hasOwnProperty("name") && dataField.hasOwnProperty("colCount") && dataField.hasOwnProperty("choices")) {
            this.setState({
              isJSONValid: true,
              btnDisabled: false
            });
            if(fields.includes("colCount")) {
            const requiredKeys = ['title', 'name', 'type', 'colCount', 'choices']
            const optionalKeys = ['isRequired', 'detail', 'isRestricted', 'placeholder','metaData'] 
            let allRequiredFound = requiredKeys.every(key => fields.includes(key)) 
            let validKeys = fields.every(key => requiredKeys.includes(key) || optionalKeys.includes(key))
              if(allRequiredFound && validKeys) {
                this.setState({optCheck: true, btnDisabled: false, updatedMetaDataSchema: JSON.parse(e.target.value)})
              }
              else {
                this.setState({optCheck: false, btnDisabled: true})
                break;
              }
            }
          }
          else {
            this.setState({ isJSONValid: false, btnDisabled: true });
            break;
          }
        }
        if(dataField.type === "dropdown") {
          if(dataField.hasOwnProperty("title") && dataField.hasOwnProperty("name") && dataField.hasOwnProperty("colCount") && dataField.hasOwnProperty("choices")) {
            this.setState({
              isJSONValid: true,
              btnDisabled: false
            });
            if(fields.includes("colCount")) {
              const requiredKeys = ['title', 'name', 'type', 'colCount', 'choices']
              const optionalKeys = ['isRequired', 'detail', 'isRestricted', 'placeholder','metaData'] 
              let allRequiredFound = requiredKeys.every(key => fields.includes(key)) 
              let validKeys = fields.every(key => requiredKeys.includes(key) || optionalKeys.includes(key))
              if(allRequiredFound && validKeys) {
                this.setState({optCheck: true, btnDisabled: false, updatedMetaDataSchema: JSON.parse(e.target.value),})
              }
              else {
                this.setState({optCheck: false, btnDisabled: true})
                break;
              }
            }
          }
          else {
            this.setState({ isJSONValid: false, btnDisabled: true });
            break;
          }
        }
        if(dataField.type === "radiogroup") {
          if(dataField.hasOwnProperty("title") && dataField.hasOwnProperty("name") && dataField.hasOwnProperty("colCount") && dataField.hasOwnProperty("choices")) {
            this.setState({
              isJSONValid: true,
              btnDisabled: false
            });
            if(fields.includes("colCount")) {
              const requiredKeys = ['title', 'name', 'type', 'colCount', 'choices']
              const optionalKeys = ['isRequired', 'detail', 'isRestricted', 'placeholder','metaData'] 
              let allRequiredFound = requiredKeys.every(key => fields.includes(key)) 
              let validKeys = fields.every(key => requiredKeys.includes(key) || optionalKeys.includes(key))
              if(allRequiredFound && validKeys) {
                this.setState({optCheck: true, btnDisabled: false, updatedMetaDataSchema: JSON.parse(e.target.value)})
              }
              else {
                this.setState({optCheck: false, btnDisabled: true})
                break;
              }
            }
          }
          else {
            this.setState({ isJSONValid: false, btnDisabled: true });
            break
          }
        }
        if(dataField.type === "text") {
          if(dataField.hasOwnProperty("title") && dataField.hasOwnProperty("name") && dataField.hasOwnProperty("inputType")) {
            this.setState({
              isJSONValid: true,
              btnDisabled: false
            });
            if(fields.includes("inputType")) {
              const requiredKeys = ['title', 'name', 'type', 'inputType']
              const optionalKeys = ['isRequired', 'detail', 'isRestricted', 'placeholder','metaData']
              let allRequiredFound = requiredKeys.every(key => fields.includes(key)) 
              let validKeys = fields.every(key => requiredKeys.includes(key) || optionalKeys.includes(key))
              if(allRequiredFound && validKeys) {
                this.setState({optCheck: true, btnDisabled: false, updatedMetaDataSchema: JSON.parse(e.target.value)})
              }
              else {
                this.setState({optCheck: false, btnDisabled: true})
                break;
              }
            }
          }
          else {
            this.setState({ isJSONValid: false, btnDisabled: true });
            break
          }
        }
        if(dataField.type === "comment") {
          if((dataField.hasOwnProperty("title") && dataField.hasOwnProperty("name")) && dataField.hasOwnProperty("rowCount")) {
            this.setState({
              isJSONValid: true,
              btnDisabled: false
            });
            if(fields.includes("rowCount")) {
              const requiredKeys = ['title', 'name', 'type', 'rowCount']
              const optionalKeys = ['isRequired', 'detail', 'isRestricted', 'placeholder','metaData'] 
              let allRequiredFound = requiredKeys.every(key => fields.includes(key)) 
              let validKeys = fields.every(key => requiredKeys.includes(key) || optionalKeys.includes(key))
              if(allRequiredFound && validKeys) {
                this.setState({optCheck: true, btnDisabled: false, updatedMetaDataSchema: JSON.parse(e.target.value)})
              }
              else {
                this.setState({optCheck: false, btnDisabled: true})
                break;
              }
            }
          }
          else {
            this.setState({ isJSONValid: false, btnDisabled: true });
            break;
          }
        }
        if(dataField.type === "image") {
          if((dataField.hasOwnProperty("title") && dataField.hasOwnProperty("name")) && dataField.hasOwnProperty("imageWidth") && dataField.hasOwnProperty("imageHeight") && dataField.hasOwnProperty("imageLink")) {
            this.setState({
              isJSONValid: true,
              btnDisabled: false
            });
            if(fields.includes("imageLink")) {
              const requiredKeys = ['title', 'name', 'type', 'imageWidth', 'imageHeight', 'imageLink']
              const optionalKeys = ['isRequired', 'detail', 'isRestricted', 'placeholder','metaData'] 
              let allRequiredFound = requiredKeys.every(key => fields.includes(key)) 
              let validKeys = fields.every(key => requiredKeys.includes(key) || optionalKeys.includes(key))
              if(allRequiredFound && validKeys) {
                this.setState({optCheck: true, btnDisabled: false, updatedMetaDataSchema: JSON.parse(e.target.value)})
              }
              else {
                this.setState({optCheck: false, btnDisabled: true})
                break;
              }
            }
          }
          else {
            this.setState({ isJSONValid: false, btnDisabled: true });
            break;
          }
        }
        let valueArr = new Set(JSON.parse(e.target.value).map(value => value.name))
        if(valueArr.size < JSON.parse(e.target.value).length) {
          this.setState({alreadyExist: true, btnDisabled: true})
        }
        if(valueArr.size == JSON.parse(e.target.value).length) {
          this.setState({alreadyExist: false, btnDisabled: false})
        }
      }
    }   
  };

  async saveUpdatedMetaData() {
    this.props.onSubmitSchema(this.state.updatedMetaDataSchema)
    this.props.setMetaDataFlag(false);
  }
  
  render() {
    const errorLabel = <div className="customErrorLabel" />;
    const { metaDataSchema } = this.props;
    
    const DuplicateCheck = this.state.alreadyExist &&
    <Message icon color='yellow'>
        <Icon name='warning sign' />
        <Message.Content>
            <Message.Header>Duplicate</Message.Header>
            Entry already exist!
        </Message.Content>
    </Message>

    const OptionsCheck = !this.state.optCheck && 
    <Message icon color='yellow'>
        <Icon name='warning sign' />
        <Message.Content>
            <Message.Header>Options Check</Message.Header>
            Entered option is not supported by Schema!
        </Message.Content>
    </Message>

    const panes = [
      {
        menuItem: 'Schema JSON', render: () => <Tab.Pane>          <Form
          noValidate
          ref={(ref) => (this.form = ref)}
          className="formcyForm"
          name="cretePack"
          id="cretePackID"
          onValidSubmit={(event) => {
            this.onSubmitNewTemplate(event);
          }}
        >
          <Grid>
            <Grid.Row>
              <Grid.Column width={16}>
                <Form.TextArea
                  required
                  name="rule"
                  label=""
                  id="Condition"
                  onChange={(e, data) => this.IsValidJSONString(e, data)}
                  value={JSON.stringify(metaDataSchema, null, 4)}
                  errorLabel={errorLabel}
                  style={{ minHeight: "300px" }}
                  instantValidation
                />
                {!this.state.isJSONValid ? (
                  <Message
                    className="bg-warning"
                    style={{
                      float: "left",
                      padding: "8px",
                      width: "calc(100% - 200px)",
                      textAlign: "center",
                    }}
                    content="Please enter valid JSON"
                  />
                ) : null}
                {DuplicateCheck}
                {OptionsCheck}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form></Tab.Pane>
      },
    ]

    return (
      <Modal
        open={this.props.open}
        onClose={this.close}
        size="medium"
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Header
          content={`Manage Metadata Schema `}
        />
        <Modal.Content>
            <div>
            <Tab panes={panes} />
            </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            className="button-cancel"
            id="cancelSchema"
            onClick={this.close}
          >
            Close
          </Button>
          <Button
            className="button-submit"
            id="cancelSchema"
            onClick={() => {this.saveUpdatedMetaData()}}
            disabled={this.state.btnDisabled ? true : false}
          >
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default ShowPlaybookMetaData;
